import { ClipboardTextIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { AddEventToReportPicker } from '@/components';
import type { ActionMenuItem } from '@/components';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { canAddEventToReport } from '@/utils/can-add-event-to-report';
import type { Event } from '@/types/event';

export interface AddEventToReportContext {
    query?: string | null;
    confidence?: number;
}

export function useAddEventToReportMenuItem() {
    const { t } = useTranslation(I18nNamespace.EVENTS);

    return (
        event: Event,
        context?: AddEventToReportContext,
    ): ActionMenuItem[] => {
        if (!canAddEventToReport(event)) {
            return [];
        }
        return [
            {
                key: 'addToReport',
                label: t('actions.addToReport'),
                icon: ClipboardTextIcon,
                submenu: (
                    <AddEventToReportPicker
                        event={event}
                        confidence={context?.confidence}
                        query={context?.query}
                    />
                ),
            },
        ];
    };
}
